export default [
  {
    value: 'F',
    text: 'Fixo',
  },
  {
    value: 'V',
    text: 'Variado',
  },
  {
    value: 'G',
    text: 'Grade',
  },
];
